import React, { useContext } from "react";
import { APIRequestContext } from "../context";
import { authAPI } from "../lib/apiService";
import { useNavigate, Link } from "react-router-dom";

export default function Register(props) {
  const { request_handler } = useContext(APIRequestContext);
  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const userData = {
      name: formData.get("name"),
      email: formData.get("email"),
      password: formData.get("password"),
    };

    const confirmPassword = formData.get("confirmPassword");

    if (userData.password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    request_handler(async () => {
      const response = await authAPI.register(userData);
      
      // Registration successful, redirect to login
      navigate("/login");
      
      return { data: { message: "Registration successful! Please login." } };
    });
  };

  return (
    <div className="Auth-form-container">
      <form onSubmit={onSubmit} className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Sign Up</h3>
          
          <div className="form-group mt-3">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              className="form-control mt-1"
              placeholder="Enter your full name"
              required
            />
          </div>
          
          <div className="form-group mt-3">
            <label>Email address</label>
            <input
              type="email"
              name="email"
              className="form-control mt-1"
              placeholder="Enter email"
              required
            />
          </div>
          
          <div className="form-group mt-3">
            <label>Password</label>
            <input
              type="password"
              name="password"
              className="form-control mt-1"
              placeholder="Enter password"
              required
              minLength="6"
            />
          </div>
          
          <div className="form-group mt-3">
            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              className="form-control mt-1"
              placeholder="Confirm password"
              required
              minLength="6"
            />
          </div>
          
          <div className="d-grid gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              Register
            </button>
          </div>
          
          <div className="text-center mt-3">
            <p>
              Already have an account?{" "}
              <Link to="/login" className="link-primary">
                Sign In
              </Link>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
}
